import {
	broncoURL,
} from 'Vulture/ENV';
import {
	getSession,
} from 'Vulture/Session.js';
import {
	s3PublicURL,
} from 'Vulture/S3.js';

// Uploads a navigation-button icon through the bronco proxy, which performs the
// S3 write server-side (the browser never handles S3 credentials). Returns the
// public ts-condor-assets URL of the object to store on the button (bronco also
// returns the env-relative `key`, kept as a fallback). Throws on a non-OK response
// or a 200 without either field, so a broken proxy is not shown as an upload.
export const uploadNavButtonIcon = async (file, accountUUID) => {
	const body = new FormData();
	body.append('file', file);
	body.append('account_uuid', accountUUID);

	const res = await fetch(`${broncoURL}/api/icon/upload`, {
		method:  'POST',
		headers: { 'X-Auth-Session': getSession().session },
		body,
	});

	if (!res.ok) {
		let msg = 'unknown error';
		try {
			// bronco returns errors via c.JSON, so the body is usually a JSON string
			// ("only PNG...") or an {error: ...}-style object. Parse it so the message
			// isn't shown with literal surrounding quotes; fall back to raw text.
			const raw = await res.text();
			try {
				const parsed = JSON.parse(raw);
				if (typeof parsed === 'string') {
					msg = parsed;
				} else {
					// {error: true, message: "..."} (e.g. an expired session) must not
					// render as "true" — take the first string-valued field.
					const text = [ parsed.message, parsed.error, ].find((v) => typeof v === 'string' && v);
					msg = text || raw;
				}
			} catch (e) {
				msg = raw;
			}
		} catch (e) { /* body may be unreadable */ }
		throw new Error(msg);
	}

	// Bronco returns the public URL (stored in the skeleton) and the env-relative key.
	// Prefer the URL; fall back to the key against a bronco that predates it.
	const { url, key } = await res.json();
	const stored = url || key;
	if (typeof stored !== 'string' || !stored) {
		throw new Error('upload response did not include the stored icon location');
	}
	return stored;
};

export const downloadCSS = async (bucketName, path) => {
	const customCssUrl = s3PublicURL(bucketName, `${path}`);
	try {
		const response = await fetch(customCssUrl);
		const blob = await response.blob();
		const blobUrl = window.URL.createObjectURL(blob);
		const temporaryAnchor = document.createElement('a');
		temporaryAnchor.style.display = 'none';
		temporaryAnchor.href = blobUrl;

		temporaryAnchor.download = path.split('/')[2];
		document.body.appendChild(temporaryAnchor);
		temporaryAnchor.click();
		window.URL.revokeObjectURL(blobUrl);
		document.body.removeChild(temporaryAnchor);
	} catch (err) {
		console.error('Custom CSS download failed.');
	}
};